import React, { useState } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DateCreate } from '../DateCreate/DateCreate';
import CircleWidget from '../CircleWidget/CircleWidget';
import { Alert, Container, Row, Col } from 'reactstrap';
import PeopleAltRoundedIcon from '@material-ui/icons/PeopleAltRounded';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import LaunchIcon from '@material-ui/icons/Launch';
import { DateCreateTimeStamp } from './../DateCreate/DateCreateTimeStamp';
import EditAlertModal from './EditAlertModal';
import UpdateIcon from '@material-ui/icons/Update';
import TrafficIcon from '@material-ui/icons/Traffic';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LinkIcon from '@material-ui/icons/Link';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteAlertModal from './DeleteAlertModal';
import AlertsSetSafetyRuleModal from './AlertsSetSafetyRuleModal';
import basePCUrl from '../../../Globals';
import './Alerts.css';

const AlertsDetailResults = (props) => {
  const [editAlertModal, setEditAlertModal] = useState(false);
  const toggleEditAlertModal = () => setEditAlertModal(!editAlertModal);

  const [alertDeleteCheckModal, setAlertDeleteCheckModal] = useState(false);
  const toggleAlertDeleteCheck = () => setAlertDeleteCheckModal(!alertDeleteCheckModal);

  const [setRuleModal, setSetRuleModal] = useState(false);
  const toggleSetRuleModal = () => setSetRuleModal(!setRuleModal);

  const [isAlertDeleteChecked, setIsAlertDeleteChecked] = useState(false);
  const [alertsForDelete, setAlertsForDelete] = useState([]);

  const [comment, setComment] = useState();

  const alertSeverity = props?.alertDetails?.severity || '1: low';

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const severityGradient = alertSeverity.includes('high')
    ? 'linear-gradient(135deg, #b71c1c 0%, #ef5350 100%)'
    : alertSeverity.includes('med')
    ? 'linear-gradient(135deg, #e6a200 0%, #ffc107 100%)'
    : 'linear-gradient(135deg, #0d47a1 0%, #42a5f5 100%)';

  const [expanded, setExpanded] = React.useState(false);

  const alertId = props.alertDetails.id;

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const { getAccessTokenSilently } = usePortalAuth();

  const severityChipStyles = {
    '3: high': {
      backgroundColor: 'rgba(255, 0, 0, 0.10)',
      color: '#c62828',
      border: '1px solid rgba(255, 0, 0, 0.25)',
      label: 'HIGH',
    },
    '2: med': {
      backgroundColor: 'rgba(241, 196, 17, 0.12)',
      color: '#9e7c00',
      border: '1px solid rgba(241, 196, 17, 0.35)',
      label: 'MED',
    },
    '1: low': {
      backgroundColor: 'rgba(30, 144, 255, 0.10)',
      color: '#1565c0',
      border: '1px solid rgba(30, 144, 255, 0.25)',
      label: 'LOW',
    },
  };

  const renderSeverityChip = (value) => {
    const chip = severityChipStyles[value];
    if (!chip) return value;
    return (
      <span
        style={{
          display: 'inline-block',
          padding: '4px 14px',
          borderRadius: 20,
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '0.75rem',
          fontWeight: 700,
          letterSpacing: '0.04em',
          backgroundColor: chip.backgroundColor,
          color: chip.color,
          border: chip.border,
        }}
      >
        {chip.label}
      </span>
    );
  };

  const alertUrlPush = (alertUrl) => {
    props.history.push({
      pathname: '/Dashboard/AnalyzeLinkAdmin',
      search: '?pad=&link=' + encodeURIComponent(props.alertDetails.URL),
      state: { from: '/AlertDetails' },
    });
  };

  const backToTable = () => {
    props.history.push('/Dashboard/Alerts');
  };

  const handleComment = (event) => {
    setComment(event.target.value);
  };

  //---------Icon Stlyes--------//
  const useIconStyles = makeStyles({
    arrow: {
      width: 40,
      height: 40,
    },
    openListDots: {
      width: 30,
      height: 30,
    },
  });

  const icons = useIconStyles();

  //---------Alert Log List Styling---------//

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      minWidth: '75vw',
      fontFamily: 'Montserrat, sans-serif',
      padding: 5,
      flexGrow: 1,
    },
    tableHead: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      fontSize: '0.82rem',
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      color: '#fff',
      backgroundColor: 'transparent',
      borderBottom: 'none',
      padding: '10px 16px',
    },
    logHeaderRow: {
      background: 'linear-gradient(90deg, #0a1e42 0%, #0b5fad 50%, #3a8ac4 100%)',
    },
    logTableCell: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '0.85rem',
      padding: '10px 16px',
      borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    },
    logTableRow: {
      transition: 'background-color 0.15s ease',
      '&:nth-of-type(even)': {
        backgroundColor: 'rgba(0, 85, 162, 0.02)',
      },
      '&:hover': {
        backgroundColor: 'rgba(0, 85, 162, 0.06)',
      },
    },
    dateCell: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '0.80rem',
      color: '#666',
      padding: '10px 16px',
      borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    },
    header: {
      fontFamily: 'Montserrat, sans-serif',
    },
    button: {
      margin: theme.spacing(1),
    },
    card: {
      width: '100%',
      fontFamily: 'Montserrat, sans-serif',
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
      overflow: 'hidden',
    },
    cardHeader: {
      background: severityGradient,
      color: '#fff',
      '& .MuiCardHeader-title': {
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: 600,
        fontSize: '1.05rem',
        color: '#fff',
      },
      '& .MuiCardHeader-subheader': {
        fontFamily: 'Montserrat, sans-serif',
        color: 'rgba(255, 255, 255, 0.85)',
        fontSize: '0.85rem',
      },
      '& .MuiIconButton-root': {
        color: '#fff',
      },
    },
    avatar: {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      color: '#fff',
      width: 44,
      height: 44,
    },
    container: {
      display: 'block',
      width: '100%',
    },
    detailsSection: {
      padding: '4px 0',
    },
    detailRow: {
      display: 'flex',
      alignItems: 'center',
      padding: '9px 0',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    detailLabel: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '0.72rem',
      fontWeight: 600,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      color: '#777',
      minWidth: 150,
      flexShrink: 0,
    },
    detailValue: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '0.9rem',
      color: '#333',
      wordBreak: 'break-word',
    },
    quickEditCard: {
      background: 'rgba(0, 85, 162, 0.03)',
      borderRadius: 10,
      border: '1px solid rgba(0, 0, 0, 0.06)',
      padding: '20px 24px',
    },
    quickEditTitle: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      fontSize: '1.1rem',
      color: '#333',
      marginBottom: 16,
    },
    textField: {
      '& .MuiOutlinedInput-root': {
        fontFamily: 'Montserrat, sans-serif',
        borderRadius: 8,
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#0055A2',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#0055A2',
        },
      },
      '& .MuiInputLabel-root': {
        fontFamily: 'Montserrat, sans-serif',
        '&.Mui-focused': {
          color: '#0055A2',
        },
      },
    },
    saveButton: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      fontSize: '0.85rem',
      letterSpacing: '0.03em',
      backgroundColor: '#0055A2',
      color: '#fff',
      borderRadius: 8,
      padding: '8px 28px',
      float: 'right',
      marginTop: 12,
      textTransform: 'none',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#003d75',
        boxShadow: 'none',
      },
    },
    actionBar: {
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      borderTop: '1px solid rgba(0, 0, 0, 0.06)',
      padding: '6px 12px',
    },
    actionButton: {
      border: '1px solid rgba(0, 0, 0, 0.10)',
      borderRadius: 8,
      padding: 8,
      margin: '0 4px',
      color: '#555',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 85, 162, 0.08)',
        borderColor: '#0055A2',
        color: '#0055A2',
      },
    },
    deleteButton: {
      border: '1px solid rgba(0, 0, 0, 0.10)',
      borderRadius: 8,
      padding: 8,
      margin: '0 4px',
      color: '#999',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
        borderColor: '#d32f2f',
        color: '#d32f2f',
      },
    },
  }));

  //---------Alert Log Table---------//

  const rows = props.alertDetails.updateLog || [];
  const classes = useStyles();

  const AlertLogTable = () => {
    return (
      <Table size="medium" aria-label="alert log">
        <TableHead>
          <TableRow className={classes.logHeaderRow}>
            <TableCell className={classes.tableHead} align="left">
              {getTranslation('Date / Time', preferredLanguage)}
            </TableCell>
            <TableCell className={classes.tableHead} align="left">
              {getTranslation('Type', preferredLanguage)}
            </TableCell>
            <TableCell className={classes.tableHead} align="left">
              {getTranslation('Comment', preferredLanguage)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow className={classes.logTableRow}>
              <TableCell className={classes.dateCell} align="left">
                <DateCreateTimeStamp date={row.logDate} />
              </TableCell>
              <TableCell className={classes.logTableCell} align="left">
                {getTranslation(row.logType, preferredLanguage)}
              </TableCell>
              <TableCell className={classes.logTableCell} align="left">
                {getTranslation(row.logEntry, preferredLanguage)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };

  //---------Alert Popover Logic---------//

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [alertDetailsMenu, setAlertDetailsMenu] = useState();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (event) => {
    setAlertDetailsMenu(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAlertDetailsMenu(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  //----------Delete Alert Logic---------//

  const deleteAlert = async () => {
    const token = await getAccessTokenSilently();

    var data = {
      id: props.alertDetails.alertId,
    };

    fetch(basePCUrl + 'alerts/DeleteAlert', {
      credentials: 'same-origin',
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }

        response.json().then((data) => {
          toggleAlertDeleteCheck();
        });
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
  };

  //----------Edit Alert API Call----------//

  const alertDetailIDPush = () => {
    props.history.push('?pad=&id=' + props.alertDetails.alertId);
  };

  const saveAlertEdits = async () => {
    const token = await getAccessTokenSilently();

    var data = {
      id: props.alertDetails.alertId,
      status: props.alertDetails.status,
      owner: '',
      severity: props.alertDetails.severity,
      comments: comment,
      sla: props.alertDetails.SLA,
    };

    fetch(basePCUrl + 'alerts/EditAlert', {
      credentials: 'same-origin',
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' + response.status);
          return;
        }
        response.json().then((data) => {});
      })
      .catch(function (err) {
        console.log('Fetch Error :-S', err);
      });
    setTimeout(() => {
      alertDetailIDPush();
    }, 2000);
  };

  const alertDetailPush = () => {
    props.history.push('/Dashboard/Alerts');
  };

  const accountForLinkLength = (linkForCheck) => {
    if (linkForCheck.length >= 30) {
      return <span style={{ wordWrap: 'break-word' }}>{linkForCheck.slice(0, 90)}...</span>;
    } else {
      return <span style={{ wordWrap: 'break-word' }}>{linkForCheck}</span>;
    }
  };

  const completeDeletion = () => {
    deleteAlert();
    alertDetailPush();
  };

  //---------Return--------//
  return (
    <div className={classes.root}>
      <Grid container direction="row" justify="center" spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Card className={classes.card}>
            <CardHeader
              className={classes.cardHeader}
              action={
                <Tooltip
                  title={getTranslation('Back to Alerts Table', preferredLanguage)}
                >
                  <IconButton aria-label="back to alerts table" onClick={backToTable}>
                    <ArrowBackIcon />
                  </IconButton>
                </Tooltip>
              }
              avatar={
                <Avatar aria-label="alert severity" className={classes.avatar}>
                  <NotificationsIcon />
                </Avatar>
              }
              title={
                props.alertDetails?.description || (
                  getTranslation('User clicked on an unknown link.', preferredLanguage)
                )
              }
              subheader={props.alertDetails?.timestamp?.createDate ? <DateCreateTimeStamp date={props.alertDetails.timestamp.createDate} /> : '—'}
            />

            <CardContent style={{ padding: '24px 28px' }}>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <div className={classes.detailsSection}>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>{getTranslation('Severity', preferredLanguage)}</span>
                      <span className={classes.detailValue}>{renderSeverityChip(props.alertDetails.severity)}</span>
                    </div>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>{getTranslation('Status', preferredLanguage)}</span>
                      <span className={classes.detailValue}>{getTranslation(props.alertDetails.status, preferredLanguage)}</span>
                    </div>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>{getTranslation('URL', preferredLanguage)}</span>
                      <span className={classes.detailValue}>{accountForLinkLength(props.alertDetails.URL)}</span>
                    </div>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>{getTranslation('Confidence Level', preferredLanguage)}</span>
                      <span className={classes.detailValue}>{props.alertDetails?.confidenceLevel || ''}</span>
                    </div>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>{getTranslation('User', preferredLanguage)}</span>
                      <span className={classes.detailValue}>{props.alertDetails.userName || '—'}</span>
                    </div>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>{getTranslation('Device', preferredLanguage)}</span>
                      <span className={classes.detailValue}>{props.alertDetails.deviceName || '—'}</span>
                    </div>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>{getTranslation('IP Address', preferredLanguage)}</span>
                      <span className={classes.detailValue}>{props.alertDetails.ipAddress || '—'}</span>
                    </div>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>SLA</span>
                      <span className={classes.detailValue}>{props.alertDetails.SLA}</span>
                    </div>
                    <div className={classes.detailRow}>
                      <span className={classes.detailLabel}>{getTranslation('Proposed Safety', preferredLanguage)}</span>
                      <span className={classes.detailValue}>{props.alertDetails?.baseAlert?.incidentDetails?.proposedSafety || ''}</span>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={classes.quickEditCard}>
                    <form>
                      <Typography className={classes.quickEditTitle}>
                        {getTranslation('Quick edit', preferredLanguage)}
                      </Typography>
                      <TextField
                        id="leave a comment as a quick edit"
                        multiline
                        required
                        rows={5}
                        label={getTranslation('Leave a comment', preferredLanguage)}
                        variant="outlined"
                        style={{ width: '100%' }}
                        className={classes.textField}
                        value={comment}
                        onChange={handleComment}
                      />
                      <Button
                        variant="contained"
                        type="submit"
                        className={classes.saveButton}
                        onClick={saveAlertEdits}
                      >
                        {getTranslation('Save', preferredLanguage)}
                      </Button>
                    </form>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={classes.actionBar} disableSpacing>
              <Tooltip title="Link Analysis">
                <IconButton className={classes.actionButton} aria-label="link analysis" onClick={alertUrlPush}>
                  <LinkIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Set Safety Rule">
                <IconButton className={classes.actionButton} aria-label="set safety rule" onClick={toggleSetRuleModal}>
                  <TrafficIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit Alert">
                <IconButton className={classes.actionButton} aria-label="edit the alert" onClick={toggleEditAlertModal}>
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={
                  !expanded
                    ? getTranslation('View Update Log', preferredLanguage)
                    : getTranslation('Close Update Log', preferredLanguage)
                }
              >
                <IconButton
                  className={classes.actionButton}
                  onClick={handleExpandClick}
                  aria-expanded={expanded}
                  aria-label="view update log"
                >
                  {!expanded ? <UpdateIcon fontSize="small" /> : <ExpandLessIcon fontSize="small" />}
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton className={classes.deleteButton} aria-label="delete this alert" onClick={toggleAlertDeleteCheck}>
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <CardContent>
                <AlertLogTable />
              </CardContent>
            </Collapse>
          </Card>
        </Grid>

        <EditAlertModal
          isOpen={editAlertModal}
          toggle={toggleEditAlertModal}
          id={props.alertDetails.id}
          history={props.history}
          alertDetails={props.alertDetails}
          preferredLanguage={props.preferredLanguage}
          getTranslation={props.getTranslation}
        />
        <DeleteAlertModal
          isOpen={alertDeleteCheckModal}
          toggle={toggleAlertDeleteCheck}
          confirmDeleteMessage={'Yes, I want to delete this alert.'}
          handleDeletion={completeDeletion}
          isAlertDeleteChecked={isAlertDeleteChecked}
          setIsAlertDeleteChecked={setIsAlertDeleteChecked}
          preferredLanguage={props.preferredLanguage}
          getTranslation={props.getTranslation}

        />
        <AlertsSetSafetyRuleModal
          isOpen={setRuleModal}
          setIsOpen={toggleSetRuleModal}
          alertUrl={props.alertDetails.URL}
          clientId={props.clientId}
          accessLevel={props.accessLevel}
          preferredLanguage={props.preferredLanguage}
          getTranslation={props.getTranslation}

        />
      </Grid>
    </div>
  );
};
export default AlertsDetailResults;

//< Typography className = { classes.header } variant = "h5" component = "h3" gutterBottom >
//    { props.alertDetails.baseAlert.title }
//        </Typography >

//< Row >
//<Col md="6">
//    <Paper id="alertDetailsColumnContainer" >
//        <div className={props.alertDetails.baseAlert.severity}>
//            <span id="alertDetailsColumnHeader"><b>Alert Link Details</b><IconButton onClick={alertUrlPush}>< LaunchIcon /></IconButton></span>
//            <div id="alertDetailsIncidentFormat">

//                <b>User:</b> {props.alertDetails.emails} <br />
//                {(props.alertDetails.type === "LinkClicks") ? <span> <b>Device:</b> {props.alertDetails.machineData.userName}<br /></span> : <span></span>}
//                {(props.alertDetails.type === "LinkClicks") ? <span> <b>IP Address:</b> {props.alertDetails.machineData.ipv4Address}<br /></span> : <span></span>}
//                <b>SLA:</b> {props.alertDetails.sla}<br />
//                <b>Severity:</b>  {capitalizeAndColorSeverity(props.alertDetails.baseAlert.severity)}<br />

//                <b>Confidence Level:</b> {props.alertDetails.baseAlert.incidentDetails.cl}<br />
//                {(props.alertDetails.type === "LinkReports") ? <span><b> Proposed Safety:</b> {props.alertDetails.baseAlert.incidentDetails.proposedSafety} <br /></span> : <span></span>}
//                <b>URL:</b> {accountForLinkLength(props.alertDetails.baseAlert.incidentDetails.url)}<br />

//            </div>
//        </div>
//    </Paper>
//</Col>
//<Col md="6">
//    <Paper id="alertLogContainer">
//        <div id="alertActionsHeader"><h4>Alert Actions</h4></div>
//        <div id="buttonContainerPadding">
//            <div id="buttonsGrid">

//                <Col md="6" className="d-flex flex-column align-items-center" >

//                    <AlertLogListPopover />
//                    <Button id="alertDetailsButton" variant="contained" className={classes.button} onClick={handleClick} color="primary" startIcon={<UpdateIcon />}>View Update Log</Button>
//                    <Button id="alertDetailsButton" variant="contained" className={classes.button} onClick={toggleEditAlertModal} color="primary" startIcon={<span id="alertDetailsButtonIcon"><EditIcon /></span>}>Edit Alert </Button>
//                    <Button id="alertDetailsButton" variant="contained" className={classes.button} onClick={toggleSetRuleModal} color="primary" startIcon={<span id="alertDetailsButtonIcon"><TrafficIcon /></span>}>Set Safety Rule</Button>

//                </Col>

//                <Col md="6" className="d-flex flex-column align-items-center">

//                    <Button id="alertDetailsButton" variant="contained" className={classes.button} onClick={backToTable} color="primary" startIcon={<span id="alertDetailsButtonIcon"><ArrowBackIcon /></span>}>Back To Table</Button>
//                    <Button id="alertDetailsButton" variant="contained" className={classes.button} onClick={alertUrlPush} color="primary" startIcon={<span id="alertDetailsButtonIcon"><LinkIcon /></span>}>Link Analysis</Button>
//                    <Button id="alertDetailsButtonDelete" variant="contained" className={classes.button} onClick={toggleAlertDeleteCheck} color="secondary" startIcon={<span id="alertDetailsButtonIcon"><DeleteIcon /></span>}>Delete Alert</Button>

//                </Col>

//            </div>
//        </div>
//    </Paper>
//</Col>
//            </Row >
